// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__YLG2-","container":"Dashboard_container__iSS6X","title":"Dashboard_title__xK-F7","list":"Dashboard_list__3VCBX"};